// extracted by mini-css-extract-plugin
export var orderSummary = "_nn-0";
export var showMoreLessButton = "_nn-1";